<div class="notification-alerts-container" nz-flex nzJustify="center" nzAlign="center" [nzVertical]="true">
  <ng-container *ngFor="let message of messages">
    <nz-alert [nzCloseable]="message.alertOptions?.closable"
              [nzType]="message.type"
              [nzMessage]="message.text"
              nzShowIcon
              class="mb-8 w-395">
    </nz-alert>
  </ng-container>
</div>
<router-outlet></router-outlet>
<app-global-loading message="Loading..."></app-global-loading>